import { createContentPropTypes } from '../../helpers/content';

const content = {
	name: 'Name',
	displayName: 'Nickname',
	sortCode: 'Sortcode',
	accountNumber: 'Account number',
	reference: 'Reference',
	deleteTemplateModalTitle: 'Are you sure you want to delete this payee?',
	infoText:
		"You're about to delete the following payee. This won't affect any scheduled payments you currently have set up for them.",
	scheduledPayementInfoText:
		'If you want to cancel a payment to this payee, like a Direct Debit or standing order, you can do this by managing your',
	scheduledPayementLink: 'scheduled payments',
	dismissButtonLabel: 'Close',
	confirmButtonLabel: 'Delete payee',
	payeeAddress: 'Payee address',
	bankAddress: 'Bank address',
	bic: 'BIC',
	iban: 'IBAN',
	chapsReference: 'CHAPS reference',
	otherPaymentReference: 'Other payment reference',
	reasonForPayment: 'Reason for payment',
	clearingCode: 'Clearing code',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
